document.addEventListener("DOMContentLoaded", () => {
    // Mark that JS is available (so we can hide stuff only in this case)
    document.body.classList.add("js-shortshifts");

    const section = document.getElementById("shortshifts-section");
    if (!section) return;

    const leftCol = section.querySelector(".shortshifts-left");
    const manager = section.querySelector(".shortshifts-manager");
    const jacob   = section.querySelector(".shortshifts-jacob");
    const bubble  = section.querySelector(".shortshifts-bubble");

    if (!leftCol || !manager || !jacob || !bubble) return;

    // Left side pieces:
    const headings = leftCol.querySelectorAll("h2"); // desktop + mobile
    const sub      = leftCol.querySelector("h4");
    const list     = leftCol.querySelector("ul");

    // Timings (ms)
    const HEADING_DURATION = 450;  // heading anim length
    const SUB_DELAY        = 350;  // after heading starts
    const LIST_DELAY       = 700;  // after heading starts
    const LEFT_TOTAL       = 1200; // whole left sequence ≈ 1.2s

    const JACOB_DURATION   = 600;
    const BUBBLE_DELAY     = 500;  // after Jacob finishes

    let animTimeouts = [];

    function clearAnimTimeouts() {
        animTimeouts.forEach(id => clearTimeout(id));
        animTimeouts = [];
    }

    function resetShortshifts() {
        clearAnimTimeouts();
        section.dataset.shortshiftsAnimating = "false";
        section.dataset.shortshiftsDone = "false";

        // Remove left-side classes
        headings.forEach(h => h.classList.remove("shortshifts-heading-in"));
        if (sub)  sub.classList.remove("shortshifts-sub-in");
        if (list) list.classList.remove("shortshifts-list-in");

        manager.classList.remove("shortshifts-manager-in");
        jacob.classList.remove("shortshifts-jacob-in");
        bubble.classList.remove("shortshifts-bubble-in");
    }

    function playShortshiftsSequence() {
        // prevent double-trigger while running
        if (section.dataset.shortshiftsAnimating === "true") return;

        section.dataset.shortshiftsAnimating = "true";

        // 1) Heading + manager fade up together
        headings.forEach(h => h.classList.add("shortshifts-heading-in"));
        manager.classList.add("shortshifts-manager-in");

        // 2) Subheading / body copy comes in shortly after
        if (sub) {
            animTimeouts.push(
                setTimeout(() => {
                    sub.classList.add("shortshifts-sub-in");
                }, SUB_DELAY)
            );
        }

        // 3) Bullet list follows – all left side done in ~1.2s
        if (list) {
            animTimeouts.push(
                setTimeout(() => {
                    list.classList.add("shortshifts-list-in");
                }, LIST_DELAY)
            );
        }

        // 4) After left is done, bring in Jacob from BELOW
        const jacobDelay = LEFT_TOTAL + 100; // tiny buffer after left sequence
        animTimeouts.push(
            setTimeout(() => {
                jacob.classList.add("shortshifts-jacob-in");
            }, jacobDelay)
        );

        // 5) After Jacob is in place + 0.5s, bubble fade + shake once
        const bubbleDelay = jacobDelay + JACOB_DURATION + (BUBBLE_DELAY - 600);
        animTimeouts.push(
            setTimeout(() => {
                bubble.classList.add("shortshifts-bubble-in");
                section.dataset.shortshiftsAnimating = "false";
                section.dataset.shortshiftsDone = "true";
            }, bubbleDelay)
        );
    }

    const observer = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                if (entry.target !== section) return;

                const ratio = entry.intersectionRatio;

                // When ~60%+ visible: play sequence
                if (ratio >= 0.6) {
                    if (section.dataset.shortshiftsDone !== "true") {
                        playShortshiftsSequence();
                    }
                } else if (ratio <= 0.2) {
                    // When mostly out of view: reset so it can replay
                    resetShortshifts();
                }
            });
        },
        {
            root: null,
            threshold: [0, 0.2, 0.6, 1]
        }
    );

    observer.observe(section);
});